import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url = `${ApiConfig.URLBase}/colonia`

const listar = async (IdCiudad: string | number, texto: string): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar/`,
        metodo: "GET",
        params: {
            IdCiudad,
            texto
        }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const ColoniaService = {
    listar,
};

export default ColoniaService;